import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-user",
  "use": "icon-user-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-user\"><defs><style type=\"text/css\"></style></defs><path d=\"M679.904 534.624a266.176 266.176 0 0 0 98.624-206.848c0-146.976-119.552-266.56-266.56-266.56s-266.56 119.584-266.56 266.56a266.176 266.176 0 0 0 98.624 206.848c-159.136 57.248-260.576 197.856-260.576 380.224 0 24.224 19.648 43.872 43.872 43.872h769.28c24.224 0 43.872-19.648 43.872-43.872 0-182.368-101.44-322.976-260.576-380.224z m-346.72-206.848c0-98.592 80.224-178.816 178.816-178.816s178.816 80.224 178.816 178.816c0 98.624-80.224 178.848-178.816 178.848s-178.816-80.224-178.816-178.848zM173.6 870.976c18.752-169.536 147.392-276.64 338.4-276.64s319.648 107.136 338.4 276.64H173.6z\" p-id=\"5742\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/user.svg
// module id = VdD3
// module chunks = 11